<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
    safetyMessage: {
        type: String,
        default: '',
    },
})

const showMessage = computed(() => {
    return props.safetyMessage !== ''
})
</script>

<template>
    <div v-if="showMessage" class="safety-message">
        <div>
            <strong>{{ $t('productDetail.tabs.safetyMessage') }}</strong>
            {{ safetyMessage }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.safety-message {
    padding: 1rem;
    border-radius: $rounded;
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 14px;

    background: $color-grey;

    @media (min-width: 500px) {
        display: flex;
        gap: 1rem;
        text-align: left;
        align-items: center;
        align-content: center;
    }
}
</style>
